import type { Vector3Like } from "./types";

export function getProfileSegmentLengths(
  points: Vector3Like[],
  extraP = true,
): number[] {
  const lengths: number[] = [];
  const epsilon = 0.000001;

  for (let i = 0; i < points.length - 1; i++) {
    const p1 = points[i];
    const p2 = points[i + 1];
    if (!p1 || !p2) continue;

    const dx = p1.x - p2.x;
    const dy = p1.y - p2.y;
    const dz = p1.z - p2.z;
    const value = Math.hypot(dx, dy, dz);

    const valueFloor = extraP
      ? Math.floor(10 * value + epsilon) / 10
      : Math.floor(value + epsilon);
    lengths.push(valueFloor);
  }

  return lengths;
}
